/*jslint devel: true */

app.reLogin = function () {
  if ($("#fnotifyReveal").data("description") === "reloginprompt") {
    return false;
  }
  if (!app.customer) {
    // User war von Anfang an nie eingeloggt
    window.location.href = app.urls;
  }
  fnotify.prompt(
    function (button, answer) {
      if (button === "alert") {
        window.location.href = app.urls;
      } else {
        // Anmeldedaten senden um erneut einzuloggen

        $.ajax({
          type: "POST",
          url: app.urls + "/auth/customer/login",
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          data: JSON.stringify({
            password: answer,
            username: app.customer.username
          })
        })
          .done(function (data) {
            if (data.success) {
              fnotify.alert(
                "Angemeldet",
                "Sie wurden erfolgreich wieder angemeldet.",
                "OK",
                function () {
                  app.wait(function () {
                    $("#anmeldeform").foundation("validateForm");
                    $("#zusammenfassungReveal .button.submit")
                      .addClass("fa-check")
                      .removeClass("ffab-spin fa-refresh")
                      .attr("disabled", false);
                  });
                }
              );
            } else if (data.code == 401) {
              fnotify.alert(
                "Fehler",
                "Das eingegebene Passwort war leider falsch. Bitte versuchen Sie es erneut.",
                "OK",
                function () {
                  app.reLogin();
                }
              );
            } else {
              fnotify.alert(
                "Fehler",
                "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
                "OK",
                function () {
                  app.reLogin();
                }
              );
            }
          })
          .fail(function () {
            fnotify.alert(
              "Fehler",
              "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
              "OK",
              function () {
                app.reLogin();
              }
            );
          });
      }
    },
    "Zeitüberschreitung",
    "Hoppla! Hat die Transportanmeldung zu lange gedauert? Sie wurden vom System abgemeldet. <br /><br />Bitte geben Sie ihr Passwort für <strong>«" +
      app.customer.username +
      "»</strong> erneut ein, um fortzufahren.",
    { success: "Login", alert: "Abmelden" },
    "Passwort",
    "small",
    true, // string_only,
    "reloginprompt" // description
  );
};
